export const WhatsappSVG = ({ color }) => {
	return (
		<svg
			width="463"
			height="413"
			viewBox="0 0 463 413"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label="WhatsApp illustration"
		>
			<title>WhatsApp</title>
			<path
				d="M315.338 375.484H276.521V375.777H315.338V375.484Z"
				fill="#EBEBEB"
			/>
			<path
				d="M425.798 372.309H415.614V372.602H425.798V372.309Z"
				fill="#EBEBEB"
			/>
			<path
				d="M403.319 367.129H322.545V367.422H403.319V367.129Z"
				fill="#EBEBEB"
			/>
			<path
				d="M202.38 374.043H166.868V374.336H202.38V374.043Z"
				fill="#EBEBEB"
			/>
			<path
				d="M156.438 374.043H133.912V374.336H156.438V374.043Z"
				fill="#EBEBEB"
			/>
			<path
				d="M54.8962 369.098H-0.000244141V369.391H54.8962V369.098Z"
				fill="#EBEBEB"
			/>
			<path
				d="M5.71918 186.102L205.299 186.102L205.299 2.35541L5.71918 2.35541L5.71918 186.102Z"
				fill="#E6E6E6"
			/>
			<path
				d="M0.970612 186.102L203.234 186.102L203.234 2.35541L0.970612 2.35541L0.970612 186.102Z"
				fill="#F5F5F5"
			/>
			<path
				d="M194.737 176.912V11.543L9.47926 11.543V176.912H194.737Z"
				fill="#FAFAFA"
			/>
			<path
				d="M171.85 176.9L109.546 11.543H83.3171L145.621 176.9H171.85Z"
				fill="white"
			/>
			<path
				d="M138.178 176.9L75.8867 11.543H57.8262L120.118 176.9H138.178Z"
				fill="white"
			/>
			<path
				d="M82.3442 176.912L82.3442 11.543H72.1947L72.1947 176.912H82.3442Z"
				fill="#E6E6E6"
			/>
			<path d="M138.822 176.9V11.5312H128.673V176.9H138.822Z" fill="#E6E6E6" />
			<path
				d="M80.5154 182.726L80.5154 4.69922L67.6937 4.69922L67.6937 182.726H80.5154Z"
				fill="#F5F5F5"
			/>
			<path
				d="M136.993 182.738V4.71094L124.172 4.71094L124.172 182.738H136.993Z"
				fill="#F5F5F5"
			/>
			<path
				d="M10.3831 176.912L10.3831 11.543H9.48061L9.48061 176.912H10.3831Z"
				fill="#E6E6E6"
			/>
			<path
				d="M408.124 359.135V231.129L26.4149 231.129V359.135H408.124Z"
				fill="#F0F0F0"
			/>
			<path
				d="M392.606 282.884V241.582C392.606 239.822 391.179 238.395 389.418 238.395L45.1434 238.395C43.3828 238.395 41.9555 239.822 41.9555 241.582V282.884C41.9555 284.644 43.3828 286.071 45.1434 286.071H389.418C391.179 286.071 392.606 284.644 392.606 282.884Z"
				fill="#F5F5F5"
			/>
			<path
				d="M392.595 348.049V294.629C392.595 292.869 391.167 291.441 389.407 291.441H45.1318C43.3712 291.441 41.944 292.869 41.944 294.629V348.049C41.944 349.81 43.3712 351.237 45.1318 351.237H389.407C391.167 351.237 392.595 349.81 392.595 348.049Z"
				fill="#F5F5F5"
			/>
			<path
				d="M322.405 237.602H112.136C112.136 239.246 112.79 240.823 113.952 241.986C115.115 243.148 116.692 243.801 118.336 243.801H316.205C317.849 243.801 319.426 243.148 320.589 241.986C321.752 240.823 322.405 239.246 322.405 237.602Z"
				fill="#F0F0F0"
			/>
			<path
				d="M322.405 290.703H112.136C112.136 291.517 112.297 292.323 112.608 293.076C112.92 293.828 113.377 294.511 113.952 295.087C114.528 295.663 115.212 296.12 115.964 296.431C116.716 296.743 117.522 296.903 118.336 296.903H316.205C317.019 296.903 317.826 296.743 318.578 296.431C319.33 296.12 320.013 295.663 320.589 295.087C321.165 294.511 321.621 293.828 321.933 293.076C322.245 292.323 322.405 291.517 322.405 290.703Z"
				fill="#F0F0F0"
			/>
			<path
				d="M436.616 359.135V231.129H408.124V359.135H436.616Z"
				fill="#E6E6E6"
			/>
			<path
				d="M26.4155 223.241V231.129L408.124 231.129V223.241L26.4155 223.241Z"
				fill="#FAFAFA"
			/>
			<path
				d="M374.571 211.816C374.571 214.847 375.774 217.754 377.917 219.897C380.06 222.039 382.967 223.243 385.998 223.243C389.028 223.243 391.935 222.039 394.078 219.897C396.221 217.754 397.425 214.847 397.425 211.816H374.571Z"
				fill="#F5F5F5"
			/>
			<path
				d="M344.11 211.816C344.11 214.847 345.314 217.754 347.457 219.897C349.6 222.039 352.506 223.243 355.537 223.243C358.568 223.243 361.474 222.039 363.617 219.897C365.76 217.754 366.964 214.847 366.964 211.816H344.11Z"
				fill="#F5F5F5"
			/>
			<path
				d="M30.5176 219.387C30.5176 221.508 40.0225 223.243 51.7425 223.243C63.4625 223.243 72.9674 221.508 72.9674 219.387H30.5176Z"
				fill="#F5F5F5"
			/>
			<path
				d="M30.5176 217.359C30.5176 219.492 40.0225 221.227 51.7425 221.227C63.4625 221.227 72.9674 219.492 72.9674 217.359H30.5176Z"
				fill="#F5F5F5"
			/>
			<path
				d="M408.124 223.241V231.129H436.615V223.241H408.124Z"
				fill="#E0E0E0"
			/>
			<path d="M424.193 0H354.53V90.7714H424.193V0Z" fill="#EBEBEB" />
			<path d="M420.945 0H351.282V90.7714H420.945V0Z" fill="#F5F5F5" />
			<path
				d="M411.593 12.1992H360.646V78.5813H411.593V12.1992Z"
				fill="white"
			/>
			<path
				d="M265.41 117.774V187.438H375.484V117.774H265.41Z"
				fill="#EBEBEB"
			/>
			<path
				d="M262.059 117.774V187.438H372.133V117.774H262.059Z"
				fill="#F5F5F5"
			/>
			<path
				d="M274.259 127.127V178.074H359.932V127.127H274.259Z"
				fill="white"
			/>
			<path
				d="M462.599 109.441H405.956V165.252H462.599V109.441Z"
				fill="#EBEBEB"
			/>
			<path
				d="M459.353 109.441H402.71V165.252H459.353V109.441Z"
				fill="#F5F5F5"
			/>
			<path
				d="M450.001 121.641H412.075V153.062H450.001V121.641Z"
				fill="white"
			/>
			<path
				d="M336.515 42.6953H279.872V98.506H336.515V42.6953Z"
				fill="#EBEBEB"
			/>
			<path d="M333.28 42.6953H276.638V98.506H333.28V42.6953Z" fill="#F5F5F5" />
			<path
				d="M323.928 54.8945H286.002V86.3158H323.928V54.8945Z"
				fill="white"
			/>
			<path
				d="M231.515 412.073C357.016 412.073 458.755 406.133 458.755 398.806C458.755 391.479 357.016 385.539 231.515 385.539C106.015 385.539 4.27637 391.479 4.27637 398.806C4.27637 406.133 106.015 412.073 231.515 412.073Z"
				fill="#F5F5F5"
			/>
			<path
				d="M309.793 61.0859H308.574V68.7977H309.793V61.0859Z"
				fill={color}
			/>
			<path
				d="M309.793 54.8144H308.621C308.615 50.3228 306.827 46.017 303.65 42.842C300.473 39.667 296.166 37.8821 291.674 37.879V36.707C296.473 36.7225 301.071 38.6348 304.465 42.0269C307.859 45.419 309.775 50.0157 309.793 54.8144Z"
				fill={color}
			/>
			<path
				d="M291.627 40.9258H129.868C122.191 40.9258 115.968 47.149 115.968 54.8257V384.744C115.968 392.42 122.191 398.644 129.868 398.644H291.627C299.304 398.644 305.527 392.42 305.527 384.744V54.8257C305.527 47.149 299.304 40.9258 291.627 40.9258Z"
				fill={color}
			/>
			<path
				opacity="0.95"
				d="M299.221 384.743V54.8134C299.221 50.0948 295.396 46.2695 290.677 46.2695L128.918 46.2695C124.199 46.2695 120.374 50.0948 120.374 54.8134L120.374 384.743C120.374 389.462 124.199 393.287 128.918 393.287H290.677C295.396 393.287 299.221 389.462 299.221 384.743Z"
				fill="white"
			/>
			<path
				d="M209.81 380.045C215.15 380.045 219.479 375.716 219.479 370.376C219.479 365.036 215.15 360.707 209.81 360.707C204.47 360.707 200.141 365.036 200.141 370.376C200.141 375.716 204.47 380.045 209.81 380.045Z"
				fill={color}
			/>
			<path
				d="M202.414 45.2969C202.414 47.4137 203.255 49.4437 204.752 50.9405C206.249 52.4373 208.279 53.2782 210.396 53.2782C212.512 53.2782 214.542 52.4373 216.039 50.9405C217.536 49.4437 218.377 47.4137 218.377 45.2969H202.414Z"
				fill={color}
			/>
			<path
				opacity="0.7"
				d="M262.586 79.9297H158.278C154.023 79.9421 149.946 81.6377 146.938 84.6462C143.929 87.6546 142.234 91.7315 142.221 95.9861V106.698C142.234 110.953 143.929 115.03 146.938 118.038C149.946 121.047 154.023 122.742 158.278 122.755H262.586L278.642 132.271V95.9392C278.614 91.6937 276.912 87.6306 273.906 84.6329C270.899 81.6352 266.831 79.945 262.586 79.9297Z"
				fill={color}
			/>
			<path
				d="M259.678 95.2695H161.124V97.9417H259.678V95.2695Z"
				fill="white"
			/>
			<path d="M259.68 104.742H180.089V107.414H259.68V104.742Z" fill="white" />
			<path
				opacity="0.15"
				d="M158.218 151.234H262.526C266.781 151.247 270.857 152.942 273.866 155.951C276.874 158.959 278.57 163.036 278.582 167.291V177.991C278.57 182.246 276.874 186.323 273.866 189.331C270.857 192.34 266.781 194.035 262.526 194.048H158.218L142.162 203.564V167.232C142.186 162.987 143.888 158.923 146.895 155.927C149.903 152.93 153.973 151.244 158.218 151.234Z"
				fill={color}
			/>
			<path
				opacity="0.5"
				d="M259.678 166.562H161.124V169.235H259.678V166.562Z"
				fill={color}
			/>
			<path
				opacity="0.5"
				d="M206.832 176.047H161.124V178.719H206.832V176.047Z"
				fill={color}
			/>
			<path
				opacity="0.5"
				d="M232.557 176.047H213.969V178.719H232.557V176.047Z"
				fill={color}
			/>
			<path
				opacity="0.7"
				d="M262.586 222.527H158.278C154.023 222.54 149.946 224.235 146.938 227.244C143.929 230.252 142.234 234.329 142.221 238.584V249.284C142.23 253.54 143.925 257.618 146.934 260.627C149.943 263.637 154.022 265.331 158.278 265.341H262.586L278.642 274.857V238.525C278.611 234.282 276.908 230.222 273.902 227.226C270.895 224.231 266.829 222.543 262.586 222.527Z"
				fill={color}
			/>
			<path
				d="M259.678 237.855H161.124V240.528H259.678V237.855Z"
				fill="white"
			/>
			<path d="M259.68 247.34H180.089V250.012H259.68V247.34Z" fill="white" />
			<path
				d="M94.8367 93.8059C89.1174 80.5271 120.304 66.6272 129.118 87.3013C144.084 93.8059 124.957 121.465 129.282 126.153C133.607 130.841 136.865 125.157 136.865 125.157C136.865 125.157 141.236 136.807 130.091 146.136C120.105 154.515 90.0667 156.789 89.9964 140.276C89.9026 118.805 102.338 111.21 94.8367 93.8059Z"
				fill="#263238"
			/>
			<path
				d="M123.515 372.577L115.123 377.464L94.9768 354.435L105.431 345L123.515 372.577Z"
				fill="#FF8B7B"
			/>
			<path
				d="M114.163 375.357L122.824 368.711C122.959 368.59 123.135 368.523 123.316 368.523C123.498 368.523 123.673 368.59 123.808 368.711L129.551 374.384C129.692 374.543 129.797 374.729 129.86 374.932C129.923 375.134 129.942 375.348 129.917 375.558C129.891 375.768 129.821 375.971 129.712 376.152C129.603 376.334 129.456 376.49 129.282 376.611C126.235 378.873 124.652 379.822 120.843 382.752C118.499 384.545 113.811 388.483 110.6 390.956C107.389 393.429 104.951 390.581 106.088 389.28C111.221 383.42 112.335 379.904 113.12 376.775C113.297 376.198 113.665 375.698 114.163 375.357Z"
				fill="#263238"
			/>
			<path
				d="M112.217 378.823C111.614 379.385 110.845 379.735 110.025 379.82C109.83 379.812 109.64 379.755 109.472 379.655C109.304 379.554 109.164 379.414 109.064 379.245C109.007 379.139 108.977 379.02 108.977 378.9C108.977 378.779 109.007 378.66 109.064 378.554C109.65 377.382 113.823 376.456 114.291 376.351C114.337 376.343 114.383 376.35 114.424 376.368C114.466 376.387 114.501 376.418 114.526 376.456C114.548 376.495 114.56 376.54 114.56 376.585C114.56 376.63 114.548 376.675 114.526 376.714C113.822 377.486 113.049 378.192 112.217 378.823ZM109.732 378.39C109.61 378.474 109.509 378.587 109.439 378.718C109.413 378.758 109.399 378.805 109.399 378.853C109.399 378.901 109.413 378.947 109.439 378.988C109.5 379.1 109.59 379.195 109.699 379.263C109.808 379.331 109.932 379.369 110.061 379.374C110.822 379.374 112.147 378.507 113.647 376.937C112.271 377.203 110.949 377.694 109.732 378.39Z"
				fill={color}
			/>
			<path
				d="M114.422 376.739H114.329C113.157 377.055 110.145 376.891 109.641 375.965C109.535 375.754 109.5 375.391 109.969 374.957C110.303 374.646 110.743 374.474 111.199 374.477C112.735 374.477 114.375 376.293 114.434 376.375C114.454 376.407 114.464 376.443 114.464 376.481C114.464 376.518 114.454 376.555 114.434 376.586C114.446 376.637 114.442 376.69 114.422 376.739ZM110.391 375.227L110.285 375.32C109.98 375.602 110.051 375.742 110.074 375.789C110.356 376.352 112.5 376.621 113.836 376.434C113.137 375.67 112.207 375.155 111.188 374.969C110.901 374.963 110.62 375.054 110.391 375.227Z"
				fill={color}
			/>
			<path
				d="M93.01 141.953C92.4591 144.473 91.838 146.747 91.1348 149.103C90.4316 151.458 89.7049 153.791 88.8611 156.041C87.2396 160.665 85.3374 165.185 83.1652 169.577L81.4423 172.859C80.8212 173.937 80.2703 175.015 79.5671 176.082L78.5592 177.664C78.2076 178.203 77.938 178.684 77.4575 179.317C77.2231 179.621 76.9887 179.926 76.6723 180.289C76.2742 180.759 75.8262 181.183 75.3362 181.555C74.7437 182.009 74.06 182.329 73.3321 182.493C72.9935 182.569 72.6477 182.608 72.3007 182.61C71.8763 182.614 71.4535 182.555 71.0467 182.434C70.2863 182.229 69.5945 181.824 69.0426 181.262C68.4893 180.708 68.086 180.023 67.8706 179.27C67.7619 178.922 67.6873 178.565 67.6479 178.203C67.5562 177.358 67.5562 176.505 67.6479 175.66C67.7299 174.957 67.8471 174.301 67.9643 173.668C68.1987 172.39 68.5034 171.195 68.8199 169.999C69.4779 167.647 70.2603 165.331 71.1639 163.061L75.8519 164.092L75.5354 171.124C75.5354 172.296 75.4651 173.398 75.4534 174.476C75.4534 175.015 75.4534 175.543 75.4534 176.012C75.4511 176.349 75.4985 176.684 75.594 177.008C75.594 177.008 75.594 177.008 75.594 176.797C75.4493 176.354 75.2001 175.952 74.8674 175.625C74.4131 175.162 73.8484 174.824 73.2266 174.64C72.8899 174.55 72.5438 174.498 72.1952 174.488C71.9194 174.493 71.6446 174.524 71.3748 174.582C70.9551 174.684 70.5578 174.863 70.2028 175.109C69.9567 175.285 70.0505 175.191 70.0974 175.109L70.3669 174.652L71.9374 171.839C72.4648 170.855 72.9453 169.847 73.461 168.851L74.9026 165.804C76.7309 161.666 78.4186 157.412 79.825 153.076C80.5516 150.907 81.2196 148.716 81.8877 146.524C82.5557 144.332 83.1534 142.071 83.6808 139.996L93.01 141.953Z"
				fill="#FF8B7B"
			/>
			<path
				d="M89.0002 129.753C85.6014 130.303 80.2102 151.903 80.2102 151.903L88.0509 157.939C88.0509 157.939 95.915 142.328 96.2549 135.308C96.4893 130.221 91.5669 129.342 89.0002 129.753Z"
				fill="#FF8B7B"
			/>
			<path
				d="M76.7069 165.134L75.3825 154.398L69.2295 163.423C69.4914 164.511 70.0641 165.499 70.8778 166.266C71.6915 167.034 72.711 167.549 73.812 167.748L76.7069 165.134Z"
				fill="#FF8B7B"
			/>
			<path
				d="M119.707 390.8L110.331 391.117L108.537 358.395L121.547 358.582L119.707 390.8Z"
				fill="#FF8B7B"
			/>
			<path
				d="M109.699 388.129L120.247 388.059C120.423 388.053 120.595 388.115 120.726 388.233C120.858 388.351 120.938 388.516 120.95 388.692L121.583 397.001C121.589 397.438 121.422 397.859 121.119 398.173C120.816 398.487 120.402 398.668 119.965 398.677C116.309 398.677 114.551 398.431 109.933 398.466C107.085 398.466 102.901 398.806 98.9866 398.841C95.0721 398.877 95.1072 394.986 96.7715 394.622C104.214 392.993 105.515 390.813 108.128 388.762C108.569 388.387 109.12 388.165 109.699 388.129Z"
				fill="#263238"
			/>
			<path
				d="M88.4255 129.68C88.4255 129.68 83.7375 130.852 83.7375 186.323L121.347 189.651C123.234 174.192 124.758 164.687 137.216 133.723C132.105 132.158 126.882 130.983 121.593 130.207C115.949 129.289 110.246 128.784 104.529 128.695C97.028 128.707 88.4255 129.68 88.4255 129.68Z"
				fill={color}
			/>
			<path
				opacity="0.2"
				d="M129.75 140.801L131.754 147.634C130.184 151.864 128.883 155.603 127.793 158.967C126.962 152.842 127.634 146.608 129.75 140.801Z"
				fill="black"
			/>
			<path
				d="M75.3825 154.398L69.2295 163.423L76.7069 162.989L80.6917 154.738L75.3825 154.398Z"
				fill="#FF8B7B"
			/>
			<path
				d="M79.2846 175.155L86.3166 175.049C86.5482 175.045 86.7762 174.991 86.9857 174.892C87.1951 174.794 87.3812 174.651 87.5318 174.475C87.6824 174.299 87.794 174.093 87.8592 173.871C87.9245 173.649 87.942 173.415 87.9105 173.186L85.7189 157.422C85.6669 157.027 85.4707 156.665 85.1678 156.405C84.865 156.145 84.4768 156.007 84.0781 156.016L77.0461 156.122C76.8144 156.122 76.5856 156.173 76.3752 156.27C76.1648 156.367 75.9778 156.508 75.8266 156.684C75.6755 156.859 75.5638 157.065 75.4992 157.288C75.4346 157.51 75.4186 157.744 75.4521 157.973L77.6438 173.737C77.6955 174.133 77.8913 174.497 78.1939 174.758C78.4965 175.02 78.8847 175.161 79.2846 175.155Z"
				fill="#263238"
			/>
			<path
				d="M123.001 110.695C121.02 116.133 118.313 126.166 121.536 130.197C115.929 134.884 109.647 138.697 102.901 141.507C98.9747 132.342 104.471 128.686 104.471 128.686C110.835 127.76 111.421 123.165 111.046 118.77L123.001 110.695Z"
				fill="#FF8B7B"
			/>
			<path
				d="M97.2404 104.457C96.2559 120.736 86.4697 125.401 88.7668 133.757C92.0133 145.477 105.257 136.3 105.257 136.3C105.257 136.3 98.0491 138.644 97.592 132.948C97.2169 128.26 113.859 128.987 109.242 117.958C106.277 110.856 97.2404 104.457 97.2404 104.457Z"
				fill="#263238"
			/>
			<path
				opacity="0.2"
				d="M119.59 114.809L111.058 118.77C111.151 119.799 111.151 120.835 111.058 121.864C112.839 122.028 117.457 120.692 119.203 117.809C119.687 116.887 119.824 115.823 119.59 114.809Z"
				fill="black"
			/>
			<path
				d="M124.477 95.3895C125.333 104.625 125.895 108.528 121.993 113.942C116.133 122.088 104.588 121.127 100.99 112.313C97.7439 104.39 96.8884 90.6077 105.292 85.5799C107.138 84.4591 109.24 83.8294 111.398 83.7506C113.557 83.6718 115.699 84.1467 117.622 85.1299C119.545 86.1131 121.185 87.572 122.385 89.3678C123.584 91.1637 124.305 93.2366 124.477 95.3895Z"
				fill="#FF8B7B"
			/>
			<path
				d="M122.438 86.1179C115.148 81.1135 109.089 90.7239 122.028 100.065C134.967 109.406 130.724 91.8021 122.438 86.1179Z"
				fill="#263238"
			/>
			<path
				d="M118.559 83.4312C121.571 86.1385 103.639 96.1239 93.8881 92.8072C84.1371 89.4904 91.966 82.0482 95.5172 81.0872C92.47 84.0289 97.8026 88.4942 100.381 85.7049C102.959 82.9155 112.511 78.0048 118.559 83.4312Z"
				fill="#263238"
			/>
			<path
				d="M83.6914 186.324C83.6914 186.324 63.8494 270.345 65.5957 291.558C67.6232 316.358 94.7433 356.335 94.7433 356.335L107.202 345.025C107.202 345.025 94.8371 312.279 85.6838 290.949C88.6138 269.618 114.515 209.354 114.515 189.055L83.6914 186.324Z"
				fill={color}
			/>
			<path
				opacity="0.6"
				d="M83.6914 186.324C83.6914 186.324 63.8494 270.345 65.5957 291.558C67.6232 316.358 94.7433 356.335 94.7433 356.335L107.202 345.025C107.202 345.025 94.8371 312.279 85.6838 290.949C88.6138 269.618 114.515 209.354 114.515 189.055L83.6914 186.324Z"
				fill="black"
			/>
			<path
				d="M109.5 346.711L94.7792 357.681L91.0054 354.81L107.156 342.07L109.5 346.711Z"
				fill={color}
			/>
			<path
				opacity="0.2"
				d="M98.3769 223.278C87.4422 238.421 86.9148 266.267 87.5945 281.878C91.3449 267.51 99.2091 246.05 105.479 226.712C105.327 219.305 103.487 216.188 98.3769 223.278Z"
				fill="black"
			/>
			<path
				d="M90.7468 186.395C90.7468 186.395 98.0132 258.953 100.439 283.448C103.322 312.525 107.553 359.159 107.553 359.159L121.547 358.573C121.547 358.573 124.618 319.042 122.344 292.941C122.754 258.367 127.852 211.358 121.289 189.606L90.7468 186.395Z"
				fill={color}
			/>
			<path
				opacity="0.6"
				d="M90.7468 186.395C90.7468 186.395 98.0132 258.953 100.439 283.448C103.322 312.525 107.553 359.159 107.553 359.159L121.547 358.573C121.547 358.573 124.618 319.042 122.344 292.941C122.754 258.367 127.852 211.358 121.289 189.606L90.7468 186.395Z"
				fill="black"
			/>
			<path
				d="M122.613 361.137L106.556 360.68L105.431 355.629L123.597 355.125L122.613 361.137Z"
				fill={color}
			/>
			<path
				d="M110.108 100.485C110.225 101.224 109.92 101.892 109.428 101.974C108.936 102.056 108.455 101.505 108.338 100.802C108.221 100.099 108.526 99.3955 109.018 99.3134C109.51 99.2314 109.991 99.7353 110.108 100.485Z"
				fill="#263238"
			/>
			<path
				d="M101.682 101.788C101.799 102.538 101.494 103.206 101.002 103.276C100.51 103.347 100.029 102.808 99.912 102.104C99.7948 101.401 100.1 100.686 100.592 100.616C101.084 100.546 101.565 101.05 101.682 101.788Z"
				fill="#263238"
			/>
			<path
				d="M100.803 100.578L98.9392 100.344C98.9392 100.344 100.076 101.598 100.803 100.578Z"
				fill="#263238"
			/>
			<path
				d="M104.448 102.527C104.044 104.329 103.398 106.068 102.526 107.696C102.948 107.907 103.411 108.024 103.882 108.038C104.354 108.052 104.823 107.963 105.257 107.778L104.448 102.527Z"
				fill="#FF5652"
			/>
			<path
				d="M110.108 109.826C109.727 109.961 109.335 110.059 108.936 110.119C108.878 110.129 108.819 110.116 108.771 110.084C108.722 110.051 108.689 110 108.678 109.943C108.673 109.914 108.674 109.884 108.68 109.855C108.687 109.826 108.7 109.799 108.717 109.775C108.735 109.75 108.757 109.73 108.782 109.715C108.808 109.699 108.836 109.689 108.865 109.685C109.797 109.564 110.686 109.224 111.461 108.692C112.235 108.16 112.872 107.452 113.319 106.626C113.346 106.576 113.391 106.537 113.445 106.518C113.499 106.498 113.559 106.499 113.612 106.521C113.639 106.532 113.663 106.549 113.684 106.57C113.704 106.591 113.72 106.616 113.731 106.643C113.742 106.67 113.748 106.699 113.747 106.729C113.747 106.758 113.741 106.787 113.729 106.814C112.961 108.252 111.662 109.333 110.108 109.826Z"
				fill="#263238"
			/>
			<path
				d="M127.044 101.693C126.981 102.591 126.741 103.466 126.339 104.271C125.937 105.075 125.38 105.793 124.7 106.381C122.895 107.928 120.984 106.569 120.644 104.33C120.328 102.326 120.902 99.1032 123.117 98.4703C123.598 98.3226 124.108 98.2962 124.602 98.3935C125.095 98.4908 125.557 98.7087 125.946 99.0279C126.334 99.347 126.638 99.7575 126.83 100.223C127.021 100.688 127.095 101.193 127.044 101.693Z"
				fill="#FF8B7B"
			/>
			<path
				d="M113.94 95.8695C113.881 95.8811 113.821 95.8809 113.763 95.8688C113.704 95.8567 113.649 95.833 113.6 95.7992C113.152 95.4665 112.631 95.2452 112.081 95.1535C111.531 95.0618 110.967 95.1023 110.435 95.2718C110.382 95.2945 110.324 95.3061 110.266 95.3059C110.207 95.3057 110.15 95.2938 110.096 95.2708C110.042 95.2479 109.994 95.2143 109.954 95.1722C109.913 95.13 109.882 95.0802 109.861 95.0256C109.819 94.9168 109.821 94.7955 109.867 94.6881C109.913 94.5807 109.999 94.4956 110.107 94.4514C110.774 94.2244 111.486 94.1623 112.182 94.2705C112.878 94.3787 113.537 94.6539 114.104 95.0725C114.199 95.1389 114.264 95.2397 114.286 95.3535C114.308 95.4673 114.285 95.5851 114.221 95.682C114.152 95.775 114.052 95.8412 113.94 95.8695Z"
				fill="#263238"
			/>
			<path
				d="M98.0255 98.5523C97.9739 98.5756 97.918 98.5877 97.8614 98.5877C97.8048 98.5877 97.7489 98.5756 97.6973 98.5523C97.6444 98.5284 97.5968 98.4941 97.5573 98.4514C97.5179 98.4088 97.4875 98.3586 97.4678 98.304C97.4481 98.2493 97.4396 98.1913 97.4428 98.1333C97.446 98.0753 97.4608 98.0185 97.4864 97.9663C97.764 97.3202 98.1934 96.7505 98.7382 96.3057C99.2829 95.8609 99.927 95.5541 100.616 95.4114C100.728 95.4031 100.839 95.4376 100.927 95.5081C101.015 95.5785 101.073 95.6795 101.089 95.7909C101.105 95.9023 101.079 96.0157 101.015 96.1083C100.951 96.201 100.854 96.266 100.745 96.2904C100.201 96.4128 99.6947 96.6627 99.2667 97.0192C98.8388 97.3758 98.5018 97.829 98.2833 98.3414C98.2569 98.3922 98.2204 98.4371 98.1761 98.4734C98.1318 98.5096 98.0805 98.5365 98.0255 98.5523Z"
				fill="#263238"
			/>
			<path
				d="M139.689 144.977C139.864 146.676 139.958 148.164 140.005 149.747C140.052 151.329 140.087 152.852 140.075 154.435C140.029 157.56 139.829 160.685 139.478 163.811C139.118 166.974 138.531 170.108 137.72 173.187C137.301 174.777 136.793 176.342 136.196 177.875C135.903 178.648 135.575 179.422 135.235 180.219C135.235 180.219 135.059 180.594 134.942 180.805C134.818 181.047 134.673 181.279 134.508 181.496C134.219 181.924 133.881 182.318 133.501 182.668C132.884 183.196 132.193 183.63 131.45 183.957C130.388 184.402 129.266 184.686 128.121 184.801C127.207 184.902 126.287 184.941 125.367 184.918C123.711 184.874 122.059 184.729 120.421 184.485C117.351 183.999 114.311 183.342 111.315 182.516C108.373 181.707 105.455 180.816 102.607 179.867C99.7587 178.918 96.9224 177.863 94.0979 176.679L95.5629 172.179C98.4109 172.8 101.306 173.456 104.189 174.007C107.072 174.558 109.943 175.179 112.803 175.601C115.663 176.023 118.522 176.456 121.288 176.632C122.61 176.737 123.937 176.76 125.261 176.703C125.827 176.676 126.391 176.613 126.949 176.515C127.287 176.462 127.614 176.36 127.922 176.21C127.922 176.21 127.922 176.21 127.746 176.304C127.638 176.387 127.543 176.486 127.465 176.597L127.324 176.808C127.324 176.808 127.219 177.042 127.324 176.89C127.547 176.281 127.769 175.718 127.957 175.038C128.355 173.773 128.684 172.472 128.977 171.147C129.525 168.438 129.917 165.698 130.149 162.943C130.406 160.154 130.489 157.318 130.489 154.481C130.489 153.063 130.489 151.645 130.489 150.227C130.489 148.809 130.36 147.344 130.278 146.078L139.689 144.977Z"
				fill="#FF8B7B"
			/>
			<path
				d="M137.124 133.724C141.167 136.361 139.796 159.344 139.796 159.344L130.279 161.254C130.279 161.254 130.197 149.534 129.178 141.928C128.486 136.76 134.241 131.837 137.124 133.724Z"
				fill="#FF8B7B"
			/>
			<path
				d="M104.54 389.221C104.426 389.069 104.349 388.892 104.314 388.705C104.279 388.518 104.289 388.326 104.341 388.143C104.363 388.007 104.418 387.879 104.502 387.771C104.586 387.662 104.696 387.577 104.822 387.522C105.994 387.018 108.666 388.834 108.97 389.033C109.005 389.058 109.031 389.092 109.046 389.132C109.06 389.172 109.063 389.215 109.052 389.256C109.042 389.3 109.02 389.34 108.99 389.373C108.959 389.406 108.92 389.431 108.877 389.444C107.646 389.737 105.454 390.112 104.634 389.315L104.54 389.221ZM108.267 389.127C107.095 388.436 105.572 387.651 104.974 387.955C104.919 387.981 104.872 388.021 104.837 388.07C104.803 388.119 104.781 388.176 104.775 388.237C104.732 388.371 104.725 388.515 104.756 388.653C104.787 388.791 104.854 388.918 104.95 389.022C105.396 389.42 106.615 389.467 108.267 389.151V389.127Z"
				fill={color}
			/>
			<path
				d="M107.612 388.389C107.28 388.056 107.017 387.661 106.838 387.227C106.659 386.792 106.568 386.327 106.569 385.857C106.62 385.683 106.724 385.53 106.867 385.418C107.01 385.307 107.184 385.243 107.366 385.236C107.529 385.21 107.697 385.222 107.855 385.271C108.014 385.32 108.159 385.404 108.28 385.517C109.229 386.408 109.065 389.103 109.053 389.221C109.052 389.261 109.04 389.3 109.02 389.335C108.999 389.37 108.97 389.399 108.936 389.42C108.902 389.437 108.863 389.447 108.825 389.447C108.786 389.447 108.748 389.437 108.713 389.42C108.294 389.136 107.922 388.788 107.612 388.389ZM108.057 385.951C108.029 385.917 107.997 385.885 107.963 385.857C107.888 385.784 107.797 385.73 107.698 385.697C107.598 385.665 107.493 385.655 107.389 385.669C107.096 385.669 107.037 385.834 107.002 385.939C106.826 386.584 107.787 388.096 108.631 388.799C108.709 387.814 108.51 386.828 108.057 385.951Z"
				fill={color}
			/>
			<path
				d="M122.215 187.47L122.625 190.986C122.719 191.255 122.367 191.501 121.933 191.455L83.2573 188.032C82.9174 188.032 82.6596 187.81 82.6713 187.599L82.894 184.176C82.894 183.942 83.2338 183.766 83.5972 183.801L121.675 187.177C121.783 187.175 121.889 187.201 121.984 187.252C122.078 187.303 122.158 187.378 122.215 187.47Z"
				fill="white"
			/>
			<path
				d="M116.402 191.317L117.422 191.399C117.632 191.399 117.797 191.329 117.808 191.2L118.043 186.758C118.043 186.629 117.89 186.5 117.691 186.488L116.66 186.395C116.46 186.395 116.285 186.465 116.273 186.594L116.039 191.047C116.039 191.176 116.203 191.293 116.402 191.317Z"
				fill={color}
			/>
			<path
				opacity="0.6"
				d="M116.402 191.317L117.422 191.399C117.632 191.399 117.797 191.329 117.808 191.2L118.043 186.758C118.043 186.629 117.89 186.5 117.691 186.488L116.66 186.395C116.46 186.395 116.285 186.465 116.273 186.594L116.039 191.047C116.039 191.176 116.203 191.293 116.402 191.317Z"
				fill="black"
			/>
			<path
				d="M86.0355 188.622L87.0552 188.715C87.2661 188.715 87.4302 188.645 87.4419 188.516L87.6763 184.063C87.6763 183.934 87.524 183.816 87.3247 183.793L86.3051 183.711C86.0941 183.711 85.9301 183.781 85.9183 183.91L85.6839 188.352C85.6722 188.481 85.8363 188.61 86.0355 188.622Z"
				fill={color}
			/>
			<path
				opacity="0.6"
				d="M86.0355 188.622L87.0552 188.715C87.2661 188.715 87.4302 188.645 87.4419 188.516L87.6763 184.063C87.6763 183.934 87.524 183.816 87.3247 183.793L86.3051 183.711C86.0941 183.711 85.9301 183.781 85.9183 183.91L85.6839 188.352C85.6722 188.481 85.8363 188.61 86.0355 188.622Z"
				fill="black"
			/>
			<path
				d="M101.225 189.969L102.245 190.063C102.444 190.063 102.62 189.981 102.62 189.852L102.866 185.41C102.866 185.281 102.714 185.164 102.503 185.141L101.483 185.047C101.284 185.047 101.108 185.129 101.108 185.258L100.862 189.7C100.862 189.829 101.026 189.911 101.225 189.969Z"
				fill={color}
			/>
			<path
				opacity="0.6"
				d="M101.225 189.969L102.245 190.063C102.444 190.063 102.62 189.981 102.62 189.852L102.866 185.41C102.866 185.281 102.714 185.164 102.503 185.141L101.483 185.047C101.284 185.047 101.108 185.129 101.108 185.258L100.862 189.7C100.862 189.829 101.026 189.911 101.225 189.969Z"
				fill="black"
			/>
			<path
				d="M97.0277 172.458L91.1677 164.641L88.73 174.017C88.73 174.017 93.0898 177.826 96.7933 176.361L97.0277 172.458Z"
				fill="#FF8B7B"
			/>
			<path
				d="M83.6681 162.918L82.0391 170.829L89.9501 174.872L91.2041 164.641L83.6681 162.918Z"
				fill="#FF8B7B"
			/>
			<path
				d="M109.24 99.2774L107.365 99.043C107.365 99.043 108.455 100.297 109.24 99.2774Z"
				fill="#263238"
			/>
		</svg>
	);
};
